<template lang="html">

  <section class="banner-child-vive animation enoturismo row-center ais" :id="$t('banners_experiencia.enoturismo.id')">

    <div class="texto column-center">
      <div class="container -half">
        <h2 class="title" v-html="$t('banners_experiencia.enoturismo.titulo')"></h2>
        <p v-html="$t('banners_experiencia.enoturismo.cuerpo')"></p>
        <a class="imagen-trip" target="_blank" href="https://www.tripadvisor.es/Attraction_Review-g1437533-d15780377-Reviews-Bodegas_Aldonza-Munera_Province_of_Albacete_Castile_La_Mancha.html">
          <img src="/static/img/tripadvisor-blanco.png" alt="" class="tripadvisor">
        </a>

      </div>
    </div>

    <div class="imagen">
      <article class="banner-enoturismo row-center plum-border -brown -xl">
        <router-link :to="$t('enlaces.enoturismo')" class="enlace-cover"></router-link>
        <router-link :to="$t('enlaces.enoturismo')" class="btn">
          <span v-html="$t('banners_experiencia.enoturismo.boton')"></span>
        </router-link>
      </article>
    </div>

  </section>

</template>

<script lang="js">
 export default  {
  name: 'banner-enoturismo',
}
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .enoturismo{
    width: 100%;
    background: $mud-brown;
  }
  .tripadvisor{
    max-width: 60px;
    padding-top:30px;
    float:center
  }

  p{
    text-align: justify;
  }

  .texto{
    background: $mud-brown;
  }

  .enoturismo > div{
    width: 50%;
  }

  @media screen and (max-width: 1023px){
    .enoturismo > div{
      width: 100%;
      height: auto;
       padding: 50px 25px;
  &.texto{
    padding: 50px 0 0 0;
    order: -1;
  }
    }
  }




</style>



// WEBPACK FOOTER //
// src/components/parts/banner-enoturismo.vue